(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper')
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-template-mobile-featured"]) return;
  try {
    
    const getpagi = document.querySelector('.AjaxinatePagination');
    if(typeof(getpagi) !== "undefined" && getpagi !== null){
      document.addEventListener("DOMContentLoaded", function() {
        const elem = getpagi.getAttribute('data-pagination');
        var endlessScroll = new Ajaxinate({
          container: '.AjaxinateLoop',
          pagination: '.AjaxinatePagination',
          loadingText: '<span class="loader-line"></span>',
          method: elem == 'scroll' ? 'scroll' : 'click'
        });
      });
    }
    
    // Preserve and restore scroll position when navigating to a product and back
    (function(){
      const storageKey = 'collection-scroll:' + window.location.pathname + window.location.search;

      function saveScrollPosition() {
        try {
          const payload = JSON.parse(sessionStorage.getItem(storageKey) || '{}');
          payload.y = window.scrollY || window.pageYOffset || 0;
          payload.t = Date.now();
          sessionStorage.setItem(storageKey, JSON.stringify(payload));
        } catch (e) { /* ignore */ }
      }

      function isProductLink(a) {
        if (!a || !a.href) return false;
        // Only handle same-tab primary clicks to product URLs
        try {
          const url = new URL(a.href, window.location.origin);
          return url.pathname.indexOf('/products/') !== -1;
        } catch (e) {
          return false;
        }
      }

      function getProductHandleFromUrl(url) {
        try {
          const u = url instanceof URL ? url : new URL(url, window.location.origin);
          const idx = u.pathname.indexOf('/products/');
          if (idx === -1) return null;
          const rest = u.pathname.slice(idx + 10);
          const handle = rest.split('/')[0];
          return handle || null;
        } catch (e) {
          return null;
        }
      }

      function getLoadedCount() {
        try {
          return document.querySelectorAll('#product-grid .grid__item').length;
        } catch (e) {
          return 0;
        }
      }

      function setRestoreParamsInUrl(payload){
        try {
          const url = new URL(window.location.href);
          if (payload && typeof payload.y === 'number') url.searchParams.set('_pos', Math.round(payload.y));
          if (payload && payload.handle) url.searchParams.set('_ph', payload.handle);
          if (payload && typeof payload.rt === 'number') url.searchParams.set('_rt', Math.round(payload.rt));
          if (payload && typeof payload.lc === 'number') url.searchParams.set('_lc', Math.round(payload.lc));
          history.replaceState(history.state, '', url.toString());
        } catch (e) { /* ignore */ }
      }

      function getRestoreParamsFromUrl(){
        try {
          const url = new URL(window.location.href);
          const y = parseInt(url.searchParams.get('_pos'), 10);
          const rt = parseInt(url.searchParams.get('_rt'), 10);
          const handle = url.searchParams.get('_ph') || null;
          const lc = parseInt(url.searchParams.get('_lc'), 10);
          return {
            y: isNaN(y) ? null : y,
            rt: isNaN(rt) ? null : rt,
            handle,
            lc: isNaN(lc) ? null : lc
          };
        } catch (e) { return { y: null, rt: null, handle: null }; }
      }

      function clearRestoreParamsInUrl(){
        try {
          const url = new URL(window.location.href);
          url.searchParams.delete('_pos');
          url.searchParams.delete('_ph');
          url.searchParams.delete('_rt');
          url.searchParams.delete('_lc');
          history.replaceState(history.state, '', url.toString());
        } catch (e) { /* ignore */ }
      }

      // Save on click within the product grid (desktop)
      document.addEventListener('click', function(ev){
        const grid = document.getElementById('product-grid');
        if (!grid) return;
        if (!grid.contains(ev.target)) return;
        const a = ev.target.closest('a');
        if (!isProductLink(a)) return;
        if (ev.defaultPrevented) return;
        if (a && (a.target === '_blank' || a.rel === 'noopener')) return;
        // Ignore modified clicks and non-left clicks
        if (ev.button !== 0 || ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey) return;
        try {
          const url = new URL(a.href, window.location.origin);
          const handle = getProductHandleFromUrl(url);
          const currentY = window.scrollY || window.pageYOffset || 0;
          const li = a.closest('li') || a.closest('.grid__item') || a;
          const cardTop = li.getBoundingClientRect().top + currentY;
          const payload = {
            y: currentY,
            t: Date.now(),
            handle: handle,
            // delta between the viewport position and the product card top
            dy: currentY - cardTop,
            // viewport-relative top of the card
            rt: li.getBoundingClientRect().top,
            lc: getLoadedCount()
          };
          sessionStorage.setItem(storageKey, JSON.stringify(payload));
          setRestoreParamsInUrl(payload);
        } catch (e) {
          saveScrollPosition();
        }
      }, true);

      // Save early on pointerdown (helps mobile where click may be unreliable)
      document.addEventListener('pointerdown', function(ev){
        const grid = document.getElementById('product-grid');
        if (!grid) return;
        if (!grid.contains(ev.target)) return;
        const a = ev.target.closest('a');
        if (!isProductLink(a)) return;
        // Ignore new-tab intents
        if (a && (a.target === '_blank' || a.rel === 'noopener')) return;
        try {
          const url = new URL(a.href, window.location.origin);
          const handle = getProductHandleFromUrl(url);
          const currentY = window.scrollY || window.pageYOffset || 0;
          const li = a.closest('li') || a.closest('.grid__item') || a;
          const cardTop = li.getBoundingClientRect().top + currentY;
          const payload = {
            y: currentY,
            t: Date.now(),
            handle: handle,
            dy: currentY - cardTop,
            rt: li.getBoundingClientRect().top,
            lc: getLoadedCount()
          };
          sessionStorage.setItem(storageKey, JSON.stringify(payload));
          setRestoreParamsInUrl(payload);
        } catch (e) { /* ignore */ }
      }, true);

      // Fallback for older mobile browsers without Pointer Events
      document.addEventListener('touchstart', function(ev){
        const grid = document.getElementById('product-grid');
        if (!grid) return;
        if (!grid.contains(ev.target)) return;
        const a = ev.target.closest('a');
        if (!isProductLink(a)) return;
        if (a && (a.target === '_blank' || a.rel === 'noopener')) return;
        try {
          const url = new URL(a.href, window.location.origin);
          const handle = getProductHandleFromUrl(url);
          const currentY = window.scrollY || window.pageYOffset || 0;
          const li = a.closest('li') || a.closest('.grid__item') || a;
          const cardTop = li.getBoundingClientRect().top + currentY;
          const payload = {
            y: currentY,
            t: Date.now(),
            handle: handle,
            dy: currentY - cardTop,
            rt: li.getBoundingClientRect().top,
            lc: getLoadedCount()
          };
          sessionStorage.setItem(storageKey, JSON.stringify(payload));
          setRestoreParamsInUrl(payload);
        } catch (e) { /* ignore */ }
      }, { capture: true, passive: true });

      // Persist current position during scrolling and before unload (covers manual refresh)
      (function(){
        let ticking = false;
        function saveDuringScroll(){
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(function(){
            try {
              const currentY = window.scrollY || window.pageYOffset || 0;
              const payload = JSON.parse(sessionStorage.getItem(storageKey) || '{}');
              payload.y = currentY;
              payload.t = Date.now();
              payload.lc = getLoadedCount();
              sessionStorage.setItem(storageKey, JSON.stringify(payload));
              setRestoreParamsInUrl(payload);
            } catch (e) { /* ignore */ }
            ticking = false;
          });
        }
        window.addEventListener('scroll', saveDuringScroll, { passive: true });
        window.addEventListener('beforeunload', saveDuringScroll);
        window.addEventListener('pagehide', saveDuringScroll);
        document.addEventListener('visibilitychange', function(){
          if (document.visibilityState === 'hidden') saveDuringScroll();
        });
      })();

      function restoreIfNeeded() {
        let navType = '';
        try {
          const navs = performance.getEntriesByType && performance.getEntriesByType('navigation');
          navType = navs && navs[0] && navs[0].type || '';
        } catch (e) { /* ignore */ }

        let data = null;
        try {
          const raw = sessionStorage.getItem(storageKey);
          if (raw) data = JSON.parse(raw);
        } catch (e) { /* ignore */ }
        // Also pull from URL params if available
        const urlData = getRestoreParamsFromUrl();
        if (!data && (urlData.y != null || urlData.handle)) {
          data = urlData;
        }
        if (!data) return;

        // Only restore when likely coming back or reloading with saved state
        const fromProduct = document.referrer && document.referrer.indexOf('/products/') !== -1;
        const isBackForward = navType === 'back_forward';
        const recentClick = data && data.handle && (Date.now() - (parseInt(data.t, 10) || 0) < 10 * 60 * 1000);
        const isReload = navType === 'reload';
        if (!fromProduct && !isBackForward && !recentClick && !isReload) return;

        // Let the browser manage native restoration when possible
        try { if ('scrollRestoration' in history) history.scrollRestoration = 'auto'; } catch(e) { /* ignore */ }

        // Prefer restoring by product handle (more reliable than raw Y)
        const handle = data.handle || urlData.handle;
        const targetY = Math.max(0, parseInt(data.y != null ? data.y : urlData.y, 10) || 0);
        const r0 = parseInt(data.rt != null ? data.rt : urlData.rt, 10);
        const targetLoadedCount = (function(){
          const lcData = parseInt(data.lc, 10);
          const lcUrl = parseInt(urlData && urlData.lc, 10);
          return (lcData || lcUrl) ? (lcData || lcUrl) : null;
        })();

        function headerOffset() {
          const headerSection = document.getElementById('shopify-section-header') || document.querySelector('header.site-header');
          return headerSection ? headerSection.offsetHeight : 0;
        }

        function scrollToY(y) {
          window.scrollTo(0, Math.max(0, y));
        }

        function cssEscapeSimple(s) {
          if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(s);
          return String(s).replace(/([\0-\x1F\x7F]|[!"#$%&'()*+,./:;<=>?@\[\\\]^`{|}~])/g, '\\$1');
        }

        function scrollToAnchorForHandle(h) {
          if (!h) return false;
          const anchor = document.querySelector('#product-grid a[href*="/products/' + cssEscapeSimple(h) + '"]');
          if (!anchor) return false;
          const li = anchor.closest('li') || anchor.closest('.grid__item') || anchor;
          const rect = li.getBoundingClientRect();
          const E1 = rect.top + (window.pageYOffset || window.scrollY || 0);
          let y;
          if (!isNaN(r0)) {
            // Aim to reproduce original viewport-relative top (r0)
            y = E1 - r0;
          } else if (data && !isNaN(parseInt(data.dy, 10))) {
            y = E1 + parseInt(data.dy, 10);
          } else if (!isNaN(targetY)) {
            y = targetY;
          } else {
            y = E1; // last resort
          }
          scrollToY(y);
          return true;
        }

        function autoLoadUntilFound(h, fallbackY) {
          let tries = 0;
          const maxTries = 80; // allow longer for mobile/network
          const maxLoads = 12; // load up to 12 pages defensively
          let loads = 0;
          let loading = false;
          let lastCount = getLoadedCount();

          function step() {
            // Try to find anchor on each step
            if (scrollToAnchorForHandle(h)) {
              cleanup(true);
              return;
            }

            // If we previously had more items visible (lc), ensure we load until at least that many exist
            const currentCount = getLoadedCount();
            if (targetLoadedCount && currentCount >= targetLoadedCount) {
              // Items should be present; if we have no handle just scroll to fallback Y
              if (h) {
                if (scrollToAnchorForHandle(h)) { cleanup(true); return; }
              } else {
                if (typeof fallbackY === 'number') scrollToY(fallbackY);
                cleanup(true);
                return;
              }
            }

            const pagi = document.querySelector('.AjaxinatePagination');
            const nextLink = pagi && pagi.querySelector('a');
            const method = pagi && (pagi.getAttribute('data-pagination') || '').toLowerCase();

            // If we are currently loading, wait until count increases
            if (loading) {
              if (getLoadedCount() > lastCount) {
                loading = false;
              }
            }

            if (!loading && pagi && nextLink && loads < maxLoads && (!targetLoadedCount || currentCount < targetLoadedCount)) {
              loads++;
              loading = true;
              lastCount = currentCount;
              if (method === 'click') {
                // In scroll mode, clicking may navigate; only click if method is click
                nextLink.click();
              } else {
                // scroll method: bring pagination into view and force scroll
                try { pagi.scrollIntoView({ block: 'end' }); } catch (e) { pagi.scrollIntoView(false); }
                window.scrollTo(0, document.body.scrollHeight);
                // Fire a synthetic scroll in case programmatic scroll isn't observed
                try { document.dispatchEvent(new Event('scroll')); } catch (e) {}
              }
            }

            tries++;
            if (tries >= maxTries) {
              // Fallback to raw Y if anchor never found
              if (fallbackY != null) {
                scrollToY(fallbackY);
              }
              cleanup(false);
              return;
            }
            setTimeout(step, 150);
          }

          function cleanup(success) {
            try { sessionStorage.removeItem(storageKey); } catch (e) { /* ignore */ }
            clearRestoreParamsInUrl();
            window.__restoringScrollInProgress = false;
          }

          step();
        }

        // If we have a handle, try to anchor to it (and auto-load more if using Ajaxinate)
        if (handle) {
          if (window.__restoringScrollInProgress) return; // Guard against concurrent runs
          window.__restoringScrollInProgress = true;
          if (!scrollToAnchorForHandle(handle)) {
            autoLoadUntilFound(handle, targetY);
          } else {
            try { sessionStorage.removeItem(storageKey); } catch (e) { /* ignore */ }
            clearRestoreParamsInUrl();
            window.__restoringScrollInProgress = false;
          }
          return;
        }

        // No handle: if we have a targetLoadedCount greater than current, auto-load until we can reach targetY
        const currentCount = getLoadedCount();
        if (targetLoadedCount && currentCount < targetLoadedCount) {
          if (window.__restoringScrollInProgress) return;
          window.__restoringScrollInProgress = true;
          autoLoadUntilFound(null, targetY);
          return;
        }

        // Fallback: restore by raw Y with a short retry loop while content paints
        let attempts = 0;
        const maxAttempts = 60; // ~1s at 16ms
        function rafStep(){
          attempts++;
          scrollToY(targetY);
          const atTarget = Math.abs((window.scrollY || window.pageYOffset || 0) - targetY) < 2;
          const scrollHeight = Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
          const canReach = (scrollHeight - window.innerHeight) >= targetY;
          if ((atTarget && canReach) || attempts >= maxAttempts) {
            scrollToY(targetY);
            try { sessionStorage.removeItem(storageKey); } catch (e) { /* ignore */ }
            clearRestoreParamsInUrl();
            window.__restoringScrollInProgress = false;
            return;
          }
          requestAnimationFrame(rafStep);
        }
        requestAnimationFrame(rafStep);
      }

      function scheduleRestore() {
        // Try immediately and then once more after a short delay (mobile paint)
        restoreIfNeeded();
        setTimeout(restoreIfNeeded, 100);
      }

      window.addEventListener('pageshow', function(e){
        // If page is restored from bfcache, browser should already restore scroll,
        // but some mobile cases still need a nudge. Don't clear storage here.
        scheduleRestore();
      });

      window.addEventListener('load', scheduleRestore);
      document.addEventListener('DOMContentLoaded', scheduleRestore);
      document.addEventListener('visibilitychange', function(){
        if (document.visibilityState === 'visible') scheduleRestore();
      });
      window.addEventListener('popstate', scheduleRestore);

      // Also observe product grid changes (filters/infinite load can re-render it)
      const gridContainer = document.getElementById('ProductGridContainer');
      if (gridContainer) {
        const mo = new MutationObserver(function(){
          // Only attempt if still have saved data
          try {
            const raw = sessionStorage.getItem(storageKey);
            if (!raw) {
              mo.disconnect();
              return;
            }
          } catch (e) { /* ignore */ }
          restoreIfNeeded();
        });
        mo.observe(gridContainer, { childList: true, subtree: true });
      }
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-template"]) return;
  try {
    
    const getpagi = document.querySelector('.AjaxinatePagination');
    if(typeof(getpagi) !== "undefined" && getpagi !== null){
      document.addEventListener("DOMContentLoaded", function() {
        const elem = getpagi.getAttribute('data-pagination');
        var endlessScroll = new Ajaxinate({
          container: '.AjaxinateLoop',
          pagination: '.AjaxinatePagination',
          loadingText: '<span class="loader-line"></span>',
          method: elem == 'scroll' ? 'scroll' : 'click'
        });
      });
    }
    
    // Preserve and restore scroll position when navigating to a product and back
    (function(){
      const storageKey = 'collection-scroll:' + window.location.pathname + window.location.search;

      function saveScrollPosition() {
        try {
          const payload = JSON.parse(sessionStorage.getItem(storageKey) || '{}');
          payload.y = window.scrollY || window.pageYOffset || 0;
          payload.t = Date.now();
          sessionStorage.setItem(storageKey, JSON.stringify(payload));
        } catch (e) { /* ignore */ }
      }

      function isProductLink(a) {
        if (!a || !a.href) return false;
        // Only handle same-tab primary clicks to product URLs
        try {
          const url = new URL(a.href, window.location.origin);
          return url.pathname.indexOf('/products/') !== -1;
        } catch (e) {
          return false;
        }
      }

      function getProductHandleFromUrl(url) {
        try {
          const u = url instanceof URL ? url : new URL(url, window.location.origin);
          const idx = u.pathname.indexOf('/products/');
          if (idx === -1) return null;
          const rest = u.pathname.slice(idx + 10);
          const handle = rest.split('/')[0];
          return handle || null;
        } catch (e) {
          return null;
        }
      }

      function getLoadedCount() {
        try {
          return document.querySelectorAll('#product-grid .grid__item').length;
        } catch (e) {
          return 0;
        }
      }

      function setRestoreParamsInUrl(payload){
        try {
          const url = new URL(window.location.href);
          if (payload && typeof payload.y === 'number') url.searchParams.set('_pos', Math.round(payload.y));
          if (payload && payload.handle) url.searchParams.set('_ph', payload.handle);
          if (payload && typeof payload.rt === 'number') url.searchParams.set('_rt', Math.round(payload.rt));
          if (payload && typeof payload.lc === 'number') url.searchParams.set('_lc', Math.round(payload.lc));
          history.replaceState(history.state, '', url.toString());
        } catch (e) { /* ignore */ }
      }

      function getRestoreParamsFromUrl(){
        try {
          const url = new URL(window.location.href);
          const y = parseInt(url.searchParams.get('_pos'), 10);
          const rt = parseInt(url.searchParams.get('_rt'), 10);
          const handle = url.searchParams.get('_ph') || null;
          const lc = parseInt(url.searchParams.get('_lc'), 10);
          return {
            y: isNaN(y) ? null : y,
            rt: isNaN(rt) ? null : rt,
            handle,
            lc: isNaN(lc) ? null : lc
          };
        } catch (e) { return { y: null, rt: null, handle: null }; }
      }

      function clearRestoreParamsInUrl(){
        try {
          const url = new URL(window.location.href);
          url.searchParams.delete('_pos');
          url.searchParams.delete('_ph');
          url.searchParams.delete('_rt');
          url.searchParams.delete('_lc');
          history.replaceState(history.state, '', url.toString());
        } catch (e) { /* ignore */ }
      }

      // Save on click within the product grid (desktop)
      document.addEventListener('click', function(ev){
        const grid = document.getElementById('product-grid');
        if (!grid) return;
        if (!grid.contains(ev.target)) return;
        const a = ev.target.closest('a');
        if (!isProductLink(a)) return;
        if (ev.defaultPrevented) return;
        if (a && (a.target === '_blank' || a.rel === 'noopener')) return;
        // Ignore modified clicks and non-left clicks
        if (ev.button !== 0 || ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey) return;
        try {
          const url = new URL(a.href, window.location.origin);
          const handle = getProductHandleFromUrl(url);
          const currentY = window.scrollY || window.pageYOffset || 0;
          const li = a.closest('li') || a.closest('.grid__item') || a;
          const cardTop = li.getBoundingClientRect().top + currentY;
          const payload = {
            y: currentY,
            t: Date.now(),
            handle: handle,
            // delta between the viewport position and the product card top
            dy: currentY - cardTop,
            // viewport-relative top of the card
            rt: li.getBoundingClientRect().top,
            lc: getLoadedCount()
          };
          sessionStorage.setItem(storageKey, JSON.stringify(payload));
          setRestoreParamsInUrl(payload);
        } catch (e) {
          saveScrollPosition();
        }
      }, true);

      // Save early on pointerdown (helps mobile where click may be unreliable)
      document.addEventListener('pointerdown', function(ev){
        const grid = document.getElementById('product-grid');
        if (!grid) return;
        if (!grid.contains(ev.target)) return;
        const a = ev.target.closest('a');
        if (!isProductLink(a)) return;
        // Ignore new-tab intents
        if (a && (a.target === '_blank' || a.rel === 'noopener')) return;
        try {
          const url = new URL(a.href, window.location.origin);
          const handle = getProductHandleFromUrl(url);
          const currentY = window.scrollY || window.pageYOffset || 0;
          const li = a.closest('li') || a.closest('.grid__item') || a;
          const cardTop = li.getBoundingClientRect().top + currentY;
          const payload = {
            y: currentY,
            t: Date.now(),
            handle: handle,
            dy: currentY - cardTop,
            rt: li.getBoundingClientRect().top,
            lc: getLoadedCount()
          };
          sessionStorage.setItem(storageKey, JSON.stringify(payload));
          setRestoreParamsInUrl(payload);
        } catch (e) { /* ignore */ }
      }, true);

      // Fallback for older mobile browsers without Pointer Events
      document.addEventListener('touchstart', function(ev){
        const grid = document.getElementById('product-grid');
        if (!grid) return;
        if (!grid.contains(ev.target)) return;
        const a = ev.target.closest('a');
        if (!isProductLink(a)) return;
        if (a && (a.target === '_blank' || a.rel === 'noopener')) return;
        try {
          const url = new URL(a.href, window.location.origin);
          const handle = getProductHandleFromUrl(url);
          const currentY = window.scrollY || window.pageYOffset || 0;
          const li = a.closest('li') || a.closest('.grid__item') || a;
          const cardTop = li.getBoundingClientRect().top + currentY;
          const payload = {
            y: currentY,
            t: Date.now(),
            handle: handle,
            dy: currentY - cardTop,
            rt: li.getBoundingClientRect().top,
            lc: getLoadedCount()
          };
          sessionStorage.setItem(storageKey, JSON.stringify(payload));
          setRestoreParamsInUrl(payload);
        } catch (e) { /* ignore */ }
      }, { capture: true, passive: true });

      // Persist current position during scrolling and before unload (covers manual refresh)
      (function(){
        let ticking = false;
        function saveDuringScroll(){
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(function(){
            try {
              const currentY = window.scrollY || window.pageYOffset || 0;
              const payload = JSON.parse(sessionStorage.getItem(storageKey) || '{}');
              payload.y = currentY;
              payload.t = Date.now();
              payload.lc = getLoadedCount();
              sessionStorage.setItem(storageKey, JSON.stringify(payload));
              setRestoreParamsInUrl(payload);
            } catch (e) { /* ignore */ }
            ticking = false;
          });
        }
        window.addEventListener('scroll', saveDuringScroll, { passive: true });
        window.addEventListener('beforeunload', saveDuringScroll);
        window.addEventListener('pagehide', saveDuringScroll);
        document.addEventListener('visibilitychange', function(){
          if (document.visibilityState === 'hidden') saveDuringScroll();
        });
      })();

      function restoreIfNeeded() {
        let navType = '';
        try {
          const navs = performance.getEntriesByType && performance.getEntriesByType('navigation');
          navType = navs && navs[0] && navs[0].type || '';
        } catch (e) { /* ignore */ }

        let data = null;
        try {
          const raw = sessionStorage.getItem(storageKey);
          if (raw) data = JSON.parse(raw);
        } catch (e) { /* ignore */ }
        // Also pull from URL params if available
        const urlData = getRestoreParamsFromUrl();
        if (!data && (urlData.y != null || urlData.handle)) {
          data = urlData;
        }
        if (!data) return;

        // Only restore when likely coming back or reloading with saved state
        const fromProduct = document.referrer && document.referrer.indexOf('/products/') !== -1;
        const isBackForward = navType === 'back_forward';
        const recentClick = data && data.handle && (Date.now() - (parseInt(data.t, 10) || 0) < 10 * 60 * 1000);
        const isReload = navType === 'reload';
        if (!fromProduct && !isBackForward && !recentClick && !isReload) return;

        // Let the browser manage native restoration when possible
        try { if ('scrollRestoration' in history) history.scrollRestoration = 'auto'; } catch(e) { /* ignore */ }

        // Prefer restoring by product handle (more reliable than raw Y)
        const handle = data.handle || urlData.handle;
        const targetY = Math.max(0, parseInt(data.y != null ? data.y : urlData.y, 10) || 0);
        const r0 = parseInt(data.rt != null ? data.rt : urlData.rt, 10);
        const targetLoadedCount = (function(){
          const lcData = parseInt(data.lc, 10);
          const lcUrl = parseInt(urlData && urlData.lc, 10);
          return (lcData || lcUrl) ? (lcData || lcUrl) : null;
        })();

        function headerOffset() {
          const headerSection = document.getElementById('shopify-section-header') || document.querySelector('header.site-header');
          return headerSection ? headerSection.offsetHeight : 0;
        }

        function scrollToY(y) {
          window.scrollTo(0, Math.max(0, y));
        }

        function cssEscapeSimple(s) {
          if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(s);
          return String(s).replace(/([\0-\x1F\x7F]|[!"#$%&'()*+,./:;<=>?@\[\\\]^`{|}~])/g, '\\$1');
        }

        function scrollToAnchorForHandle(h) {
          if (!h) return false;
          const anchor = document.querySelector('#product-grid a[href*="/products/' + cssEscapeSimple(h) + '"]');
          if (!anchor) return false;
          const li = anchor.closest('li') || anchor.closest('.grid__item') || anchor;
          const rect = li.getBoundingClientRect();
          const E1 = rect.top + (window.pageYOffset || window.scrollY || 0);
          let y;
          if (!isNaN(r0)) {
            // Aim to reproduce original viewport-relative top (r0)
            y = E1 - r0;
          } else if (data && !isNaN(parseInt(data.dy, 10))) {
            y = E1 + parseInt(data.dy, 10);
          } else if (!isNaN(targetY)) {
            y = targetY;
          } else {
            y = E1; // last resort
          }
          scrollToY(y);
          return true;
        }

        function autoLoadUntilFound(h, fallbackY) {
          let tries = 0;
          const maxTries = 80; // allow longer for mobile/network
          const maxLoads = 12; // load up to 12 pages defensively
          let loads = 0;
          let loading = false;
          let lastCount = getLoadedCount();

          function step() {
            // Try to find anchor on each step
            if (scrollToAnchorForHandle(h)) {
              cleanup(true);
              return;
            }

            // If we previously had more items visible (lc), ensure we load until at least that many exist
            const currentCount = getLoadedCount();
            if (targetLoadedCount && currentCount >= targetLoadedCount) {
              // Items should be present; if we have no handle just scroll to fallback Y
              if (h) {
                if (scrollToAnchorForHandle(h)) { cleanup(true); return; }
              } else {
                if (typeof fallbackY === 'number') scrollToY(fallbackY);
                cleanup(true);
                return;
              }
            }

            const pagi = document.querySelector('.AjaxinatePagination');
            const nextLink = pagi && pagi.querySelector('a');
            const method = pagi && (pagi.getAttribute('data-pagination') || '').toLowerCase();

            // If we are currently loading, wait until count increases
            if (loading) {
              if (getLoadedCount() > lastCount) {
                loading = false;
              }
            }

            if (!loading && pagi && nextLink && loads < maxLoads && (!targetLoadedCount || currentCount < targetLoadedCount)) {
              loads++;
              loading = true;
              lastCount = currentCount;
              if (method === 'click') {
                // In scroll mode, clicking may navigate; only click if method is click
                nextLink.click();
              } else {
                // scroll method: bring pagination into view and force scroll
                try { pagi.scrollIntoView({ block: 'end' }); } catch (e) { pagi.scrollIntoView(false); }
                window.scrollTo(0, document.body.scrollHeight);
                // Fire a synthetic scroll in case programmatic scroll isn't observed
                try { document.dispatchEvent(new Event('scroll')); } catch (e) {}
              }
            }

            tries++;
            if (tries >= maxTries) {
              // Fallback to raw Y if anchor never found
              if (fallbackY != null) {
                scrollToY(fallbackY);
              }
              cleanup(false);
              return;
            }
            setTimeout(step, 150);
          }

          function cleanup(success) {
            try { sessionStorage.removeItem(storageKey); } catch (e) { /* ignore */ }
            clearRestoreParamsInUrl();
            window.__restoringScrollInProgress = false;
          }

          step();
        }

        // If we have a handle, try to anchor to it (and auto-load more if using Ajaxinate)
        if (handle) {
          if (window.__restoringScrollInProgress) return; // Guard against concurrent runs
          window.__restoringScrollInProgress = true;
          if (!scrollToAnchorForHandle(handle)) {
            autoLoadUntilFound(handle, targetY);
          } else {
            try { sessionStorage.removeItem(storageKey); } catch (e) { /* ignore */ }
            clearRestoreParamsInUrl();
            window.__restoringScrollInProgress = false;
          }
          return;
        }

        // No handle: if we have a targetLoadedCount greater than current, auto-load until we can reach targetY
        const currentCount = getLoadedCount();
        if (targetLoadedCount && currentCount < targetLoadedCount) {
          if (window.__restoringScrollInProgress) return;
          window.__restoringScrollInProgress = true;
          autoLoadUntilFound(null, targetY);
          return;
        }

        // Fallback: restore by raw Y with a short retry loop while content paints
        let attempts = 0;
        const maxAttempts = 60; // ~1s at 16ms
        function rafStep(){
          attempts++;
          scrollToY(targetY);
          const atTarget = Math.abs((window.scrollY || window.pageYOffset || 0) - targetY) < 2;
          const scrollHeight = Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
          const canReach = (scrollHeight - window.innerHeight) >= targetY;
          if ((atTarget && canReach) || attempts >= maxAttempts) {
            scrollToY(targetY);
            try { sessionStorage.removeItem(storageKey); } catch (e) { /* ignore */ }
            clearRestoreParamsInUrl();
            window.__restoringScrollInProgress = false;
            return;
          }
          requestAnimationFrame(rafStep);
        }
        requestAnimationFrame(rafStep);
      }

      function scheduleRestore() {
        // Try immediately and then once more after a short delay (mobile paint)
        restoreIfNeeded();
        setTimeout(restoreIfNeeded, 100);
      }

      window.addEventListener('pageshow', function(e){
        // If page is restored from bfcache, browser should already restore scroll,
        // but some mobile cases still need a nudge. Don't clear storage here.
        scheduleRestore();
      });

      window.addEventListener('load', scheduleRestore);
      document.addEventListener('DOMContentLoaded', scheduleRestore);
      document.addEventListener('visibilitychange', function(){
        if (document.visibilityState === 'visible') scheduleRestore();
      });
      window.addEventListener('popstate', scheduleRestore);

      // Also observe product grid changes (filters/infinite load can re-render it)
      const gridContainer = document.getElementById('ProductGridContainer');
      if (gridContainer) {
        const mo = new MutationObserver(function(){
          // Only attempt if still have saved data
          try {
            const raw = sessionStorage.getItem(storageKey);
            if (!raw) {
              mo.disconnect();
              return;
            }
          } catch (e) { /* ignore */ }
          restoreIfNeeded();
        });
        mo.observe(gridContainer, { childList: true, subtree: true });
      }
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["parallax-banner"] && !Shopify.designMode) return;
  try {
    
  class ParallaxImage extends HTMLElement {
    constructor() {
      super();
      
    }
  connectedCallback() {
    const sectionId = this.getAttribute('section-id');
    const image = this.querySelector('img');
    const aosAnimation = this.getAttribute('data-aos');

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          window.addEventListener('scroll', this.parallaxEffect);
        } else {
          window.removeEventListener('scroll', this.parallaxEffect);
        }
      });
    });

    const section = document.getElementById(sectionId);
    observer.observe(section);

    const imageContainer = this;
    imageContainer.style.transform = 'translateY(0)';

    this.parallaxEffect = () => {
      const scrollPosition = window.pageYOffset;
      const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
      const parallaxValue = (scrollPosition / maxScroll) * 50;
      image.style.transform = `translateY(-${parallaxValue}%) scale(1.2)`;
    };

  }
}

customElements.define('parallax-image', ParallaxImage);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-content"]) return;
  try {
    
  class productPairs extends HTMLElement {
    connectedCallback() {
      fetch(this.dataset.url).
      then((response) => {
        if (!response.ok) {
          throw new Error("HTTP error! Status: ".concat(response.status));
        }
        return response.text();
      }).
      then((response) => {
        var frag = document.createDocumentFragment(),
          fetchedContent = document.createElement('div');
        frag.appendChild(fetchedContent);
        fetchedContent.innerHTML = response;

        var replacementContent = fetchedContent.querySelector("[data-id=\"".concat(CSS.escape(this.dataset.id), "\"]"));
        if (replacementContent) {
          this.innerHTML = replacementContent.innerHTML;
        }
      });
    }
  }

  customElements.define('product-pairs', productPairs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    

class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.productlist-item')) {
      this.classList.add('product-recommendations--loaded');
      const swiperContainer = this.querySelector('.productlist-swiper');
      const sliderWrapper = this.querySelector('.productlist-wrapper');
      if (swiperContainer) {
        const sliderEffect = swiperContainer.getAttribute('data-slider-effect');
        const useFadeEffect = sliderEffect === 'fade';
        const spaceBetweenAttr = parseInt(swiperContainer.getAttribute('data-space-between'), 10);
        let spaceBetween = Number.isNaN(spaceBetweenAttr) ? 0 : spaceBetweenAttr;
        let mobileSpaceBetween = 10;
        if (!Number.isNaN(spaceBetweenAttr)) {
          if (spaceBetween <= 0) {
            mobileSpaceBetween = 0;
          } else if (spaceBetween < mobileSpaceBetween) {
            mobileSpaceBetween = spaceBetween;
          }
        }
        const perviewDesktopValue = parseFloat(swiperContainer.getAttribute('data-perview-desktop'));
        const perviewMobileValue = parseFloat(swiperContainer.getAttribute('data-perview-mobile'));
        let desktopSlides = perviewDesktopValue > 0 ? perviewDesktopValue : 4;
        let mobileSlides = perviewMobileValue > 0 ? Math.min(perviewMobileValue, desktopSlides) : 1;
        let tabletSlides = Math.max(Math.ceil(perviewMobileValue || 1), 3);
        if (tabletSlides > desktopSlides) {
          tabletSlides = desktopSlides;
        }
        if (useFadeEffect) {
          desktopSlides = 1;
          mobileSlides = 1;
          tabletSlides = 1;
          spaceBetween = 0;
          mobileSpaceBetween = 0;
        }
        new Swiper(swiperContainer, {
          slidesPerView: desktopSlides,
          freeMode: false,
          autoHeight: true,
          calculateHeight:true,
          freeModeSticky: true,
          centeredSlides: false,
          grabCursor: true,
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
          preloadImages: true,
          updateOnImagesReady: true,
          spaceBetween: spaceBetween,
          effect: useFadeEffect ? 'fade' : 'slide',
          fadeEffect: {
            crossFade: true
          },
          observer: true,
          observeParents: true,
          parallax:true,
          a11y: true,
          keyboard: {
            enabled: true,
          },
          breakpoints: {
            0: {
              slidesPerView: useFadeEffect ? 1 : 'auto',
              centeredSlides: mobileSlides <= 1,
              centeredSlidesBounds: mobileSlides <= 1,
              spaceBetween: mobileSpaceBetween
            },
            576: {
              slidesPerView: mobileSlides,
              centeredSlides: mobileSlides <= 1,
              centeredSlidesBounds: mobileSlides <= 1
            },
            768: {
              slidesPerView: tabletSlides,
              centeredSlides: false,
              centeredSlidesBounds: false
            },
            992: {
              slidesPerView: desktopSlides,
              centeredSlides: false,
              centeredSlidesBounds: false,
              spaceBetween: spaceBetween
            }
          },
          scrollbar: {
            el: sliderWrapper ? sliderWrapper.querySelector(".swiper-scrollbar") : null,
          },
          navigation: {
            nextEl: sliderWrapper ? sliderWrapper.querySelector(".swiper-button-next") : null,
            prevEl: sliderWrapper ? sliderWrapper.querySelector(".swiper-button-prev") : null,
          },
        });
      } else {
        console.error('No element with class "productlist-swiper" found.');
      }
    }
    try { if (typeof jdgm !== 'undefined' && jdgm && typeof jdgm.customizeBadges === 'function') jdgm.customizeBadges(); } catch(e) { console.warn('jdgm.customizeBadges skipped:', e); }
    try {
      if (window.SPR && typeof theme !== 'undefined' && theme.review) {
        if (typeof $ === 'function' && $('.shopify-product-reviews-badge').length > 0) {
          window.SPR.registerCallbacks();
          window.SPR.initRatingHandler();
          window.SPR.initDomEls();
          window.SPR.loadProducts();
          window.SPR.loadBadges();
        }
      }
    } catch(e) { console.warn('SPR init skipped:', e); }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 500px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-1"]) return;
  try {
    
class productPairsRight extends HTMLElement {
  connectedCallback() {
    fetch(this.dataset.url).
    then((response) => {
      if (!response.ok) {
        throw new Error("HTTP error! Status: ".concat(response.status));
      }
      return response.text();
    }).
    then((response) => {
      var frag = document.createDocumentFragment(),
        fetchedContent = document.createElement('div');
      frag.appendChild(fetchedContent);
      fetchedContent.innerHTML = response;

      var replacementContent = fetchedContent.querySelector("[data-id=\"".concat(CSS.escape(this.dataset.id), "\"]"));
      if (replacementContent) {
        this.innerHTML = replacementContent.innerHTML;
      }
    });
  }
}

customElements.define('product-pairsright', productPairsRight);

class BuyNow extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.handleClick.bind(this));
  }

  connectedCallback() {
    this.checkAgreement();
  }

  handleClick(event) {
    const agreeCheckbox = this.querySelector('.checkbox__input');
    const checkoutButton = this.querySelector('.product-form__buynow');
    
    if (event.target === agreeCheckbox || event.target === this.querySelector('.checkbox__label')) {
      if (agreeCheckbox.checked) {
        checkoutButton.classList.remove('disabled');
      } else {
        checkoutButton.classList.add('disabled');
      }
    }
  }
  checkAgreement() {
    const agreeCheckbox = this.querySelector('.checkbox__input');
    return agreeCheckbox.checked;
  }
}

customElements.define('buy-now', BuyNow);

var initPhotoSwipeFromDOM = function(gallerySelector) {

// parse slide data (url, title, size ...) from DOM elements 
// (children of gallerySelector)
var parseThumbnailElements = function(el) {
  var thumbElements = Array.prototype.slice.call(document.querySelectorAll('.photo-image')),
    numNodes = thumbElements.length,
    items = [],
    figureEl,
    linkEl,
    size,
    item;

  for (var i = 0; i < numNodes; i++) {

    figureEl = thumbElements[i]; // <figure> element
    // include only element nodes 
    if (figureEl.nodeType !== 1) {
      continue;
    }

    linkEl = figureEl.children[0]; // <a> element
    if(linkEl.getAttribute('data-size')){
      size =  linkEl.getAttribute('data-size').split('x') ;
    }else{
      size =  [] ;
    }
    
    

    // create slide object
    item = {
      src: linkEl.getAttribute('href'),
      w: parseInt(size[0], 10),
      h: parseInt(size[1], 10)
    };



    if (figureEl.children.length > 1) {
      // <figcaption> content
      item.title = figureEl.children[1].innerHTML;
    }

    if (linkEl.children.length > 0) {
      // thumbnail element, retrieving thumbnail url
      item.msrc = linkEl.children[0].getAttribute('data-phototview');
    }

    item.el = figureEl; // save link to element for getThumbBoundsFn
    items.push(item);
  }

  return items;
};

// find nearest parent element
var closest = function closest(el, fn) {
  return el && (fn(el) ? el : closest(el.parentNode, fn));
};

// triggers when user clicks on thumbnail
var onThumbnailsClick = function(e) {
  e = e || window.event;
  e.preventDefault ? e.preventDefault() : e.returnValue = false;

  var eTarget = e.target || e.srcElement;

  // find root element of slide
  var clickedListItem = closest(eTarget, function(el) {
    return (el.tagName && el.tagName.toUpperCase() === 'FIGURE');
  });

  if (!clickedListItem) {
    return;
  }

  // find index of clicked item by looping through all child nodes
  // alternatively, you may define index via data- attribute
  var clickedGallery = clickedListItem.parentNode,
    childNodes = clickedListItem.parentNode.childNodes,
    numChildNodes = childNodes.length,
    nodeIndex = 0,
    index;

  for (var i = 0; i < numChildNodes; i++) {
    if (childNodes[i].nodeType !== 1) {
      continue;
    }

    if (childNodes[i] === clickedListItem) {
      index = nodeIndex;
      break;
    }
    nodeIndex++;
  }



  if (index >= 0) {
    // open PhotoSwipe if valid index found
    openPhotoSwipe(index, clickedGallery);
  }
  return false;
};

// parse picture index and gallery index from URL (#&pid=1&gid=2)
var photoswipeParseHash = function() {
  var hash = window.location.hash.substring(1),
    params = {};

  if (hash.length < 5) {
    return params;
  }

  var vars = hash.split('&');
  for (var i = 0; i < vars.length; i++) {
    if (!vars[i]) {
      continue;
    }
    var pair = vars[i].split('=');
    if (pair.length < 2) {
      continue;
    }
    params[pair[0]] = pair[1];
  }

  if (params.gid) {
    params.gid = parseInt(params.gid, 10);
  }

  return params;
};

var openPhotoSwipe = function(index, galleryElement, disableAnimation, fromURL) {
  var pswpElement = document.querySelectorAll('.pswp')[0],
    gallery,
    options,
    items;

  items = parseThumbnailElements(galleryElement);

  // define options (if needed)
  options = {
    maxSpreadZoom: 1, 
    bgOpacity: 0.7,
    zoomEl: true,
    history: false,
    pinchToClose: false,
    closeOnScroll: false,

    // define gallery index (for URL)
    galleryUID: galleryElement.getAttribute('data-pswp-uid'),

  };

  // PhotoSwipe opened from URL
  if (fromURL) {
    if (options.galleryPIDs) {
      // parse real index when custom PIDs are used 
      // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
      for (var j = 0; j < items.length; j++) {
        if (items[j].pid == index) {
          options.index = j;
          break;
        }
      }
    } else {
      // in URL indexes start from 1
      options.index = parseInt(index, 10) - 1;
    }
  } else {
    options.index = parseInt(index, 10);
  }

  // exit if index not found
  if (isNaN(options.index)) {
    return;
  }

  if (disableAnimation) {
    options.showAnimationDuration = 0;
  }

  // Pass data to PhotoSwipe and initialize it
  gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
  gallery.init();
};

// loop through all gallery elements and bind events
var galleryElements = document.querySelectorAll(gallerySelector);

for (var i = 0, l = galleryElements.length; i < l; i++) {
  galleryElements[i].setAttribute('data-pswp-uid', i + 1);
  galleryElements[i].onclick = onThumbnailsClick;
}

// Parse URL and open gallery if it contains #&pid=3&gid=1
var hashData = photoswipeParseHash();
if (hashData.pid && hashData.gid) {
  openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true);
}
};

// execute above function
initPhotoSwipeFromDOM('.my-gallery');


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline"] && !Shopify.designMode) return;
  try {
    
  !function(){function e(e){this.element=e,this.blocks=this.element.getElementsByClassName("js-cd-block"),this.images=this.element.getElementsByClassName("js-cd-img"),this.contents=this.element.getElementsByClassName("js-cd-content"),this.offset=.8,this.hideBlocks()}e.prototype.hideBlocks=function(){if(!(!1 in document.documentElement))for(var e,t=this,s=0;s<this.blocks.length;s++)e=s,t.blocks[e].getBoundingClientRect().top>window.innerHeight*t.offset&&(t.images[e].classList.add("cd-is-hidden"),t.contents[e].classList.add("cd-is-hidden"))},e.prototype.showBlocks=function(){if(!(!1 in document.documentElement))for(var e,t=this,s=0;s<this.blocks.length;s++)e=s,t.contents[e].classList.contains("cd-is-hidden")&&t.blocks[e].getBoundingClientRect().top<=window.innerHeight*t.offset&&(t.images[e].classList.add("or-timeline__img--bounce-in"),t.contents[e].classList.add("or-timeline__content--bounce-in"),t.images[e].classList.remove("cd-is-hidden"),t.contents[e].classList.remove("cd-is-hidden"))};var t,s=document.getElementsByClassName("js-or-timeline"),n=[],i=!1;if(s.length>0){for(var o=0;o<s.length;o++)t=o,n.push(new e(s[t]));window.addEventListener("scroll",function(e){i||(i=!0,window.requestAnimationFrame?window.requestAnimationFrame(c):setTimeout(c,250))})}function c(){n.forEach(function(e){e.showBlocks()}),i=!1}}();

  } catch(e) { console.error(e); }
})();
})();
